import {isSafari} from 'app/utils/detect/isBrowser';

export function initPageShow() {
    if (isSafari()) {
        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                window.location.reload();
            }
        });
    }
}
